import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faBars,
  faTimes,
  faPhone,
  faEnvelope,
  faUser
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faBars,
  faTimes,
  faPhone,
  faEnvelope,
  faUser
)

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
app.mount('#app')
